export const environment = {
  production: true,
  baseUrl: "https://namdorang.com",
  kakaoAppKey: "9a3a9a83360564352e26bd5bf40c5909",
  nhn: {
    objectStorageContainer: "test",
  },
};
